<template>
<b-container fluid>
  <loading :active.sync="isLoading" color="#00AB63"></loading>
  <b-row>
    <b-col sm="6">
      <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar empresas</h4>
          <div class="media text-muted pt-3">
            <b-form @submit.prevent="add()" v-if="show" style="width: 100%;">
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Nombre" label-for="input-1">
                    <b-form-input v-model="form.name" type="text" required placeholder="Nombre" />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Porcentaje" label-for="input-1">
                    <b-form-input v-model="form.percentage" type="number" required placeholder="Porcentaje" step="any"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button type="submit" class="float-right boton_createch" variant="primary">
                <i class="far fa-save"></i> Guardar
              </b-button>
            </b-form>
          </div>
        </div>
    </b-col>
    <b-col sm="6">
      <div class="my-3 p-3 bg-white rounded shadow-sm">
        <h4 class="border-bottom border-gray pb-2 mb-0">Empresas</h4>
        <div class="media text-muted pt-3">
          <b-container fluid>
            <!-- Main table element -->
            <b-table
              show-empty
              small
              stacked="md"
              :items="companies"
              :fields="fields"
              empty-text="No hay registros para mostrar"
            >
              <template v-slot:cell(actions)="row">
                <b-button 
                  size="sm"
                  @click="info(row.item,$event.target)"
                  class="float-right btn_borrar"
                >
                  <i class="far fa-trash-alt"></i>
                </b-button>
                <b-button 
                  size="sm"
                  @click="edit(row.item,$event.target)"
                  class="float-right mr-1 btn_editar"
                >
                  <i class="far fa-edit"></i>
                </b-button>
              </template>
            </b-table>

            <!-- Info modal -->
            <b-modal
              :id="infoModal.id"
              :title="infoModal.title" 
              centered
              ok-title="Eliminar"
              @ok="deleteEmpresas(infoModal.eliminar)"
              cancel-title="Cancelar"
            >
              <p
                style="text-align:center; font-size:25px; font-weight:bold;"
              >¿Está seguro que desea eliminar?</p>
            </b-modal>
            <!-- Editar modal -->
            <b-modal :id="editModal.id" :title="editModal.title" hide-footer centered>
              <b-container>
                <b-row>
                  <b-form @submit.prevent="put()" v-if="show" style="width: 100%;">
                    <b-row>
                      <b-col sm="6">
                        <b-form-group label="Nombre" label-for="input-1">
                          <b-form-input
                            v-model="editModal.new.name"
                            type="text"
                            required
                            placeholder="Tarifa"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group label="Porcentaje" label-for="input-1">
                          <b-form-input
                            v-model="editModal.new.percentage"
                            type="number"
                            required
                            placeholder="Costo"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col>
                        <b-button
                          type="submit"
                          variant="primary"
                          size="sm"
                          class="float-right"
                        >Editar</b-button>
                        <b-button
                          variant="secondary"
                          size="sm"
                          class="float-right mr-1"
                          @click="ocultaModal(editModal.id)"
                        >Cancelar</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-row>
              </b-container>
            </b-modal>
          </b-container>
        </div>
      </div> 
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import axios from "axios";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      show: true,
      companies: [],
      form: {
        name: "",
        percentage: ""
      },
      fields: [
        { key: "name", sortable: true, label: "Nombre" },
        { key: "percentage", sortable: true, label: "Porcentaje" },
        { key: "actions", label: "" }
      ],
      infoModal: {
        id: "info-modal",
        title: "",
        eliminar: ""
      },
      editModal: {
        id: "edit-modal",
        title: "",
        new: { _id: null, name: "", percentage: null }
      }
    } 
  }, 
  created() {
    this.gets();
  },
  methods: {
    add() {
      this.isLoading = true;
      axios
        .post("company", { name: this.form.name, percentage: this.form.percentage })
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe una empresa con ese nombre.", "Error");
          } else {
            this.form.name = "";
            this.form.percentage = "";
            this.gets();
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast("Ocurrió un error inesperado.", "Error");
        });
    },
    gets() {
      this.isLoading = true;
      axios
        .get("companies")
        .then(res => { 
          if (res.data) {  
            this.companies = res.data;
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast(
            "Ocurrió un error inesperado al consultar las empresas existentes.",
            "Error"
          );
        });
    },
    put() {
      this.isLoading = true;
      console.log(this.editModal.new);
      axios
        .put("company/" + this.editModal.new._id, {
          name: this.editModal.new.name,
          percentage: this.editModal.new.percentage
        })
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe una empresa con ese nombre.", "Error");
          } else {
            this.gets();
            this.ocultaModal(this.editModal.id);
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast("Ocurrió un error inesperado.", "Error");
          this.ocultaModal(this.editModal.id);
        });
    }, 
    deleteEmpresas(company_id){ 
      axios
        .delete("company/" + company_id)
        .then(res => {
          this.resetDeleteModal();
          this.gets();
        })
        .catch(error => {
          this.makeToast("Ocurrió un error inesperado.", "Error");
        });
    },
    info(item, button) {
      this.infoModal.title = `Eliminar empresa: ${item.name}`;
      this.infoModal.eliminar = item._id;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    edit(item, button) {
      this.editModal.new.name = item.name;
      this.editModal.new._id = item._id;
      this.editModal.new.percentage = item.percentage;
      this.editModal.title = `Editar empresa: ${item.name}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    resetDeleteModal() {
      this.infoModal = {
        id: "info-modal",
        title: "",
        eliminar: ""
      };
    },
    ocultaModal(id) {
      this.$bvModal.hide(id);
    }
  }
}
</script>

<style>

</style>